import React from 'react';
import { Tooltip } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useDiscussion } from './contexteDiscussion';
import { CHARTE_COLORS as C } from '../../variables/constants';

/**
 * Puce d'ancrage posée sur une ligne du dossier - une victime, une offre, un document.
 *
 * POURQUOI ANCRER PLUTÔT QUE TOUT METTRE DANS UN FIL UNIQUE.
 * « Le taux RC de la victime 2 me paraît faux », noyé dans quatre-vingts messages, est
 * introuvable dans un an. Accroché à la victime 2, il est là où on le cherchera. C'est
 * la différence entre un chat collé à un dossier et une conversation qui sait de quoi
 * elle parle.
 *
 * DISCRÈTE PAR DÉFAUT, VISIBLE QUAND ELLE PORTE QUELQUE CHOSE. Sans discussion attachée,
 * la puce n'apparaît qu'au survol de sa ligne (`cb-ancre-discussion` + le CSS parent) :
 * une icône permanente sur chaque ligne d'un tableau dense ajouterait une colonne de
 * bruit. Dès qu'un message existe, elle s'affiche avec son compteur - c'est alors une
 * information, plus une affordance.
 */
export default function PastilleDiscussion({ type, id, libelle, taille = 12 }) {
  const { t } = useTranslation('commun');
  const { disponible, ouvrirSur, compteursAncres } = useDiscussion();
  if (!disponible || !id) return null;

  const nombre = compteursAncres[`${type}:${id}`] || 0;

  return (
    <Tooltip title={nombre
      ? t('pastilleDiscussion.messagesSur', { count: nombre, libelle })
      : t('pastilleDiscussion.discuterDe', { libelle })}>
      <span
        className={nombre ? undefined : 'cb-ancre-discussion'}
        onClick={(e) => { e.stopPropagation(); ouvrirSur({ type, id, libelle }); }}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 3, cursor: 'pointer',
          color: nombre ? C.greenMid : C.faint, fontSize: taille, fontWeight: 600,
          padding: '0 3px', borderRadius: 4, verticalAlign: 'middle',
        }}
      >
        <MessageOutlined style={{ fontSize: taille }} />
        {nombre > 0 && <span style={{ fontSize: taille - 1 }}>{nombre}</span>}
      </span>
    </Tooltip>
  );
}
